import {
  FoundationalReportItem,
  GlossaryItem,
  HintItem,
  Live101TrainingItem,
  MethodGuideItem,
  TechGuideItem,
  VideoItem,
  SectorPrimer,
} from '@gslc/models';
import { GlobalState } from './globalState';

export const mutations = {
  refreshVideos(state: GlobalState, videos: VideoItem[]): void {
    state.videos.splice(0);
    state.videos.push(...videos);
  },
  refreshVideoSettings(state: GlobalState, settings: any): void {
    state.videoSettings = settings ?? { hide_card_in_video: false };
  },
  refreshMethodGuides(
    state: GlobalState,
    methodGuides: MethodGuideItem[]
  ): void {
    state.methodGuides.splice(0);
    state.methodGuides.push(...methodGuides);
  },
  refreshLive101Trainings(
    state: GlobalState,
    live101Trainings: Live101TrainingItem[]
  ): void {
    state.live101Trainings.splice(0);
    state.live101Trainings.push(...live101Trainings);
  },
  refreshFoundReports(
    state: GlobalState,
    foundReports: FoundationalReportItem[]
  ): void {
    state.reports.splice(0);
    state.reports.push(...foundReports);
  },
  refreshTechGuides(state: GlobalState, techGuides: TechGuideItem[]): void {
    state.technicalGuides.splice(0);
    state.technicalGuides.push(...techGuides);
  },
  refreshHints(state: GlobalState, hints: HintItem[]): void {
    state.hints.splice(0);
    state.hints.push(...hints);
  },
  togglePageLoading(
    state: GlobalState,
    pageLoading: { loading: boolean; path: '/' }
  ): void {
    state.pageLoading = pageLoading;
  },
  updateWindowWidth(state: GlobalState, currentWidth: number): void {
    state.windowWidth = currentWidth;
  },
  updateSearchQuery(state: GlobalState, searchQuery: string): void {
    state.searchQuery = searchQuery;
  },
  setCurrentVideo(state: GlobalState, currentVideo: any): void {
    state.currentVideo = currentVideo;
  },
  setCurrentFoundationalReport(
    state: GlobalState,
    currentFoundationalReport: any
  ): void {
    state.currentFoundationalReport = currentFoundationalReport;
  },
  setGlossaries(state: GlobalState, glossaries: GlossaryItem[]): void {
    state.glossaries = glossaries;
  },
  setGlossarySearch(state: GlobalState, glossarySearch: string): void {
    state.glossarySearch = glossarySearch;
  },
  setGlossarySearchIsLetter(
    state: GlobalState,
    glossarySearchIsLetter: boolean
  ): void {
    state.glossarySearchIsLetter = glossarySearchIsLetter;
  },
  setGlossaryLoading(state: GlobalState, glossaryLoading: boolean): void {
    state.glossaryLoading = glossaryLoading;
  },
  setSectorPrimers(state: GlobalState, sectorPrimers: SectorPrimer[]): void {
    state.sectorPrimers = sectorPrimers;
  },
};
